<template>
  <div data-testid="SampleReportsModule">
    <router-view v-if="moduleIsReady" />
    <div v-else>Loading Reports...</div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop } from 'vue-property-decorator';

export default class SampleReportsModule extends Vue {
  created() {
    this.bootstrap();
  }

  get moduleIsReady() {
    return true;
  }

  bootstrap() {
  }
}
</script>
